import styled from "@emotion/styled";

export const Left = styled.div`
  inline-size: 350px;
`;
export const Filter = styled.div`
  display: flex;
  justify-content: space-between;

  margin-block: 32px 17px;
`;
